import React from 'react';
import Row from 'components/common/Row';
import Col from 'components/common/Col';
import TeamMemberRow from './TeamMemberRow';

class TeamList extends React.PureComponent {
  render() {
    return (
      <Row justify="flex-start">
        {this.props.users.map(user => (
          <Col xs={24} key={user._id}>
            <TeamMemberRow user={user} organization={this.props.organization} />
          </Col>
        ))}
      </Row>
    );
  }
}

export default TeamList;



// WEBPACK FOOTER //
// ./src/routes/admin-organization-detail/TeamList/index.js